











import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Logo extends Vue {
  @Prop({ type: Boolean, default: false }) fade!: boolean
  @Prop({ type: Boolean, default: false }) redirect!: boolean

  get src() {
    return this.fade
      ? require('@/assets/img/logo.png')
      : require('@/assets/img/logo_colored.png')
  }

  handleClick() {
    if (this.redirect) {
      this.$router.push('/')
    }
  }
}
